import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getCities } from 'models/cities'; // Importing getCities function from cities model
import { getTags } from 'models/tags'; // Importing getTags function from tags model
import { getPositions } from 'models/positions'; // Importing getPositions function from positions model
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix

/**
 * Class representing the FilterReportsView.
 * @extends JetView
 */
export default class FilterReportsView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Datepicker configuration
        const fecha = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for date selection
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange', // CSS class for styling
                    readonly: true, // Makes the input read-only
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label with icon
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
            ],
        };

        // Transaction ID section configuration
        const transactionId = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        // Upper section layout containing datepicker and transaction ID
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1', // Responsive layout
                    margin: 10,
                    cols: [fecha, transactionId], // Columns containing fecha and transactionId
                },
            ],
        };

        // Button configuration for actions
        const buttons = {
            margin: 10,
            minWidth: 200,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Button label
                    autowidth: true, // Automatic width
                    click: () => {
                        this.getRoot().clear(); // Clears the form inputs
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'), // Button label
                    type: 'form', // Button type
                    autowidth: true, // Automatic width
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('userAffiliates:filter', [
                            filterdata, // Trigger filter event with form data
                        ]);
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form', // Form view
            rows: [upper_section, buttons], // Rows containing upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
